<template>
    <table class="table table-sm mt-3 mb-0">
        <thead>
            <tr>
                <th scope="col" class="text-center">মাসিক দাবী</th>
                <th scope="col" class="text-center">বকেয়া দাবী</th>
                <th scope="col" class="text-center">সারচার্জ দাবী</th>
                <th scope="col" class="text-center">সংযোগ ফী</th>
                <th scope="col" class="text-center">মোট দাবী</th>
                <th scope="col" class="text-center">মোট আদায়</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="text-center">
                    <span v-if="dataList.amount>0">{{ thousands_separators(dataList.amount) }}</span>
                    <span v-else-if="dataList.amount==null">0</span>
                    <span v-else-if="dataList.amount==0">0</span>
                    <span v-else></span>
                </td>
                <td class="text-center">
                    <span v-if="dataList.due_amount>0">{{ thousands_separators(dataList.due_amount) }}</span>
                    <span v-else-if="dataList.due_amount==null">0</span>
                    <span v-else-if="dataList.due_amount==0">0</span>
                    <span v-else></span>
                </td>
                <td class="text-center">
                    <span v-if="dataList.due_charge>0">{{ thousands_separators(dataList.due_charge) }}</span>
                    <span v-else-if="dataList.due_charge==null">0</span>
                    <span v-else-if="dataList.due_charge==0">0</span>
                    <span v-else></span>
                </td>
                <td class="text-center">
                    <span v-if="dataList.connection_fee>0">{{ thousands_separators(dataList.connection_fee) }}</span>
                    <span v-else-if="dataList.connection_fee==null">0</span>
                    <span v-else-if="dataList.connection_fee==0">0</span>
                    <span v-else></span>
                </td>
                <td class="text-center">
                    <span v-if="dataList.total>0">{{ thousands_separators(dataList.total) }}</span>
                    <span v-else-if="dataList.total==null">0</span>
                    <span v-else-if="dataList.total==0">0</span>
                    <span v-else></span>
                </td>
                <td class="text-center">
                    <span v-if="dataList.mot_adai>0">{{ thousands_separators(dataList.mot_adai) }}</span>
                    <span v-else-if="dataList.mot_adai==null">0</span>
                    <span v-else-if="dataList.mot_adai==0">0</span>
                    <span v-else></span>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    data(){
        return {
        }
    },
    methods:{
        thousands_separators(num){
            var num_parts = num.toString().split(".");
            num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return num_parts.join(".");
        },
    },
    mounted(){
    },
    computed:{
    },
    components: {
    },
    props: ['dataList']
}
</script>
<style scoped>
    .formInput{ height: 41px;}
    .date-time-picker label,.card{font-family: 'Hind Siliguri Light' !important; font-size: 16px;}
    .form-control{ font-size: 16px;}
    .btn-info{ color: #fff; text-transform: capitalize; height: 42px; line-height: 42px; padding: 0rem 0.75rem;}
</style>
